export { default } from "./PortfolioComparison";



// WEBPACK FOOTER //
// ./src/components/pages/dashboardComponents/PortfolioComparison/index.js